<ion-card class="firebase-card">
  <ion-card-header>
    <ion-card-title>{{ message.title }}</ion-card-title>
  </ion-card-header>

  <ion-card-content>
    {{ message.body }}
  </ion-card-content>

  <ion-buttons class="ion-justify-content-end ion-padding">
    <ion-button mode="md" fill="outline" size="small" (click)="dismiss.emit()">Dismiss</ion-button>
  </ion-buttons>
</ion-card>
